import {
  getLoanById,
  patchSetBusinessDetailsToBusinessOnboardingDetails,
  patchSetHoldersToBusinessOnboardingDetails,
} from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

interface UseBusinessKycProps {
  loanId: string;
}

export const useBusinessKyc = ({ loanId }: UseBusinessKycProps) => {
  const { data: loan, revalidate } = useCache(getLoanById, { loanId });

  const { request, loading } = useRequest();

  const setBusinessDetailsToOnboardingDetails = async (businessDetails: RequestBusinessDetailsType) => {
    if (!loan) throw new Error('loan not found');
    try {
      await request(patchSetBusinessDetailsToBusinessOnboardingDetails, businessDetails);
      revalidate();
    } catch (error) {
      throw new Error('error');
    }
  };

  const setHoldersToBusinessOnboardingDetails = async (holdersDetails: RequestHoldersDetailsType) => {
    if (!loan) throw new Error('loan not found');
    try {
      await request(patchSetHoldersToBusinessOnboardingDetails, holdersDetails);
      revalidate();
    } catch (error) {
      throw new Error('error');
    }
  };

  return {
    setBusinessDetailsToOnboardingDetails,
    setHoldersToBusinessOnboardingDetails,
    loading,
  };
};

export type RequestBusinessDetailsType = typeof patchSetBusinessDetailsToBusinessOnboardingDetails extends (
  params: infer P,
) => void
  ? P
  : never;

export type RequestHoldersDetailsType = typeof patchSetHoldersToBusinessOnboardingDetails extends (
  params: infer P,
) => void
  ? P
  : never;
